/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Ai_SpentInputs */

const en_ai_spent = /** @type {(inputs: Ai_SpentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} used this month`)
};

const de_ai_spent = /** @type {(inputs: Ai_SpentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} in diesem Monat verbraucht`)
};

/**
* | output |
* | --- |
* | "{amount} used this month" |
*
* @param {Ai_SpentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_spent = /** @type {((inputs: Ai_SpentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_SpentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_spent(inputs)
	return en_ai_spent(inputs)
});